module.exports = __webpack_public_path__ + "img/comment-dollar.db1ddfb9.svg";